<template>
  <div class="p-3">
    <b-container fluid>
      <b-row>

        <!-- LEFT ROLE LIST -->
        <b-col md="2" class="pr-0">
          <b-list-group>
            <b-list-group-item
              v-for="(role, index) in roles"
              :key="role.id"
              :active="currentRoleIndex === index"
              button
              @click="loadRole(role, index)"
            >
              {{ index + 1 }}) {{ role.role_name }}
            </b-list-group-item>
          </b-list-group>

          <div v-if="!roles.length" class="text-muted p-2">
            No roles assigned
          </div>
        </b-col>

        <!-- RIGHT CONTENT -->
        <b-col md="10" class="pl-0">
          <seminar-evaluation
            v-if="selectedRole"
            :key="evaluationKey"
            :methodId="methodId"
            :course_id="course_id"
            :seminar_role_id="selectedRole.id"
          />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>
<script>
import SeminarEvaluation from "./SeminarEvaluation.vue";

export default {
  name: "SeminarTypeTab",

  components: {
    SeminarEvaluation
  },

  props: {
    methodId: {
      type: Number,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    },
    course_id: {
      type: [Number, String],
      required: true
    }
  },

  data() {
    return {
      currentRoleIndex: 0,
      selectedRole: null,
      evaluationKey: 0
    };
  },

  watch: {
    roles: {
      immediate: true,
      handler(roles) {
        if (roles.length) {
          this.currentRoleIndex = 0;
          this.selectedRole = roles[0];
          this.refreshEvaluation();
        } else {
          this.selectedRole = null;
        }
      }
    }
  },

  methods: {
    loadRole(role, index) {
      this.currentRoleIndex = index;
      this.selectedRole = role;
      this.refreshEvaluation();
    },

    refreshEvaluation() {
      this.evaluationKey++;
    }
  }
};
</script>
